var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var _CategoryMapping;
const _PlayerError = class _PlayerError extends Error {
  constructor({
    severity,
    code,
    playerCode,
    data,
    originalError
  }) {
    super();
    this.name = "PlayerError";
    this.severity = severity;
    this.category = _PlayerError.findCategory(code);
    this.code = code;
    this.stack = originalError?.stack;
    this.data = data;
    this.playerCode = playerCode;
    this.message = this.toString();
    if (!this.stack) {
      if (Error.captureStackTrace) {
        Error.captureStackTrace(this, this.constructor);
      } else {
        try {
          throw new Error("Stack generator");
        } catch (error) {
          this.stack = error.stack;
        }
      }
    }
  }
  toString() {
    return `${this.category}: ${this.code} (${this.playerCode})`;
  }
  toJSON() {
    return {
      severity: this.severity,
      category: this.category,
      code: this.code,
      stack: this.stack,
      data: this.data,
      playerCode: this.playerCode
    };
  }
  static findCategory(code) {
    return Object.keys(__privateGet(_PlayerError, _CategoryMapping)).find((category) => __privateGet(_PlayerError, _CategoryMapping)[category].includes(code)) || this.Category.OTHER;
  }
};
_CategoryMapping = new WeakMap();
/** @enum {string} */
__publicField(_PlayerError, "Severity", {
  CRITICAL: "CRTICAL",
  HANDLED: "HANDLED",
  NON_CRITICAL: "NON_CRITICAL"
});
/** @enum {string} */
__publicField(_PlayerError, "Category", {
  NETWORK: "NETWORK",
  STREAMING: "STREAMING",
  MANIFEST: "MANIFEST",
  DRM: "DRM",
  OTHER: "OTHER"
});
/** @enum {string} */
__publicField(_PlayerError, "Code", {
  // Network
  MALFORMED_DATA_URI: "MALFORMED_DATA_URI",
  BAD_HTTP_STATUS: "BAD_HTTP_STATUS",
  HTTP_ERROR: "HTTP_ERROR",
  TIMEOUT: "TIMEOUT",
  FILTER_ERROR: "FILTER_ERROR",
  NETWORK_OTHER: "NETWORK_OTHER",
  // Streaming
  SEGMENT_MISSING: "SEGMENT_MISSING",
  INVALID_SEGMENT: "INVALID_SEGMENT",
  MISSING_TEXT_PLUGIN: "MISSING_TEXT_PLUGIN",
  STREAMING_UNSUPPORTED: "STREAMING_UNSUPPORTED",
  STREAMING_ERROR: "STREAMING_ERROR",
  RESTRICTIONS_CANNOT_BE_MET: "RESTRICTIONS_CANNOT_BE_MET",
  // Manifest
  INVALID_MANIFEST: "INVALID_MANIFEST",
  PERIOD_FLATTENING_FAILED: "PERIOD_FLATTENING_FAILED",
  // DRM
  INVALID_KEYSYSTEM: "INVALID_KEYSYSTEM",
  KEYSYSTEM_UNAVAILABLE: "KEYSYSTEM_UNAVAILABLE",
  DRM_INITIALIZATION_FAILED: "DRM_INITIALIZATION_FAILED",
  INVALID_SERVER_CERTIFICATE: "INVALID_SERVER_CERTIFICATE",
  FAILED_TO_GENERATE_LICENSE_REQUEST: "FAILED_TO_GENERATE_LICENSE_REQUEST",
  LICENSE_REQUEST_FAILED: "LICENSE_REQUEST_FAILED",
  LICENSE_RESPONSE_REJECTED: "LICENSE_RESPONSE_REJECTED",
  DRM_INVALID_CONFIG: "DRM_INVALID_CONFIG",
  LICENSE_EXPIRED: "LICENSE_EXPIRED",
  SERVER_CERTIFICATE_REQUEST_FAILED: "SERVER_CERTIFICATE_REQUEST_FAILED",
  DRM_RESTRICTED_OUTPUT: "DRM_RESTRICTED_OUTPUT",
  OFFLINE_SESSION_REMOVED: "OFFLINE_SESSION_REMOVED",
  DRM_OTHER: "DRM_OTHER",
  // Other
  LOAD_INTERRUPTED: "LOAD_INTERRUPTED",
  OPERATION_ABORTED: "OPERATION_ABORTED",
  BAD_PLAYER_INITIALIZATION: "BAD_PLAYER_INITIALIZATION",
  OBJECT_DESTROYED: "OBJECT_DESTROYED",
  OTHER: "OTHER"
});
__privateAdd(_PlayerError, _CategoryMapping, {
  [_PlayerError.Category.NETWORK]: [
    _PlayerError.Code.MALFORMED_DATA_URI,
    _PlayerError.Code.BAD_HTTP_STATUS,
    _PlayerError.Code.HTTP_ERROR,
    _PlayerError.Code.TIMEOUT,
    _PlayerError.Code.FILTER_ERROR,
    _PlayerError.Code.NETWORK_OTHER
  ],
  [_PlayerError.Category.STREAMING]: [
    _PlayerError.Code.SEGMENT_MISSING,
    _PlayerError.Code.INVALID_SEGMENT,
    _PlayerError.Code.MISSING_TEXT_PLUGIN,
    _PlayerError.Code.STREAMING_UNSUPPORTED,
    _PlayerError.Code.STREAMING_ERROR,
    _PlayerError.Code.RESTRICTIONS_CANNOT_BE_MET
  ],
  [_PlayerError.Category.MANIFEST]: [
    _PlayerError.Code.INVALID_MANIFEST,
    _PlayerError.Code.PERIOD_FLATTENING_FAILED
  ],
  [_PlayerError.Category.DRM]: [
    _PlayerError.Code.INVALID_KEYSYSTEM,
    _PlayerError.Code.KEYSYSTEM_UNAVAILABLE,
    _PlayerError.Code.DRM_INITIALIZATION_FAILED,
    _PlayerError.Code.INVALID_SERVER_CERTIFICATE,
    _PlayerError.Code.FAILED_TO_GENERATE_LICENSE_REQUEST,
    _PlayerError.Code.LICENSE_REQUEST_FAILED,
    _PlayerError.Code.LICENSE_RESPONSE_REJECTED,
    _PlayerError.Code.DRM_INVALID_CONFIG,
    _PlayerError.Code.LICENSE_EXPIRED,
    _PlayerError.Code.SERVER_CERTIFICATE_REQUEST_FAILED,
    _PlayerError.Code.DRM_RESTRICTED_OUTPUT,
    _PlayerError.Code.OFFLINE_SESSION_REMOVED,
    _PlayerError.Code.DRM_OTHER
  ],
  [_PlayerError.Category.OTHER]: [
    _PlayerError.Code.LOAD_INTERRUPTED,
    _PlayerError.Code.OPERATION_ABORTED,
    _PlayerError.Code.BAD_PLAYER_INITIALIZATION,
    _PlayerError.Code.OBJECT_DESTROYED,
    _PlayerError.Code.OTHER
  ]
});
let PlayerError = _PlayerError;

export { PlayerError };
//# sourceMappingURL=PlayerError.js.map
